import * as $ from 'jquery';
import {safeLocalStorage} from '../utils/safeLocalStorage.js';
import * as utils from '../utils.js';
import * as Ajax from '../utils/ajax.js';
import Cropper from 'cropperjs/dist/cropper.esm';
import { b64toBlob, trimCanvas } from '../utils/image_utils.js';
import * as BI from '../tracking/bi.js';
import '../utils/share.js';
import cloneProductSetupBtns from '../clone_product.js';
import { getImageBase64 } from '../utils/getImageBase64';
import appPdf from '../utils/app_pdf.js';
import { setPublishedProductsIndicator } from '../components/progress-bar.js';
import { userReportBlock } from './user_report_block.js'
import { bannerFriendDiscount } from './banner_friend_discount.js';
import { onLoad } from '../utils/onLoad';
import { appHasCapability } from '../utils/app';

// Data models tracking (BI & Zendesk)
import {
    UserAlertConfigureBIModel,
    UserReviewStartBIModel
} from '../BI/models';
import {sendAppEvent} from '../tracking/app-events.js';
import {shippingDataChecks} from './shippingDataChecks.js';
let cropperObj;

$(document).on('show.bs.modal', '[id^="modal-profile-follow"]', function (e) {
    let type = $(e.relatedTarget).data('follow-type'),
        userId = $(e.relatedTarget).data('userid');
    if (!$(e.relatedTarget).hasClass('empty')) {
        $('.js-spinner').toggleClass('d-none, d-flex');
        $('#modal-profile-' + type + ' .modal-body').load('/profile/' + type + '/' + userId, () => $('.js-spinner').toggleClass('d-none, d-flex'), $(e.relatedTarget).addClass('empty'));
    }
});

$(document).on('submit', '.js-btn-load-more-follow', function (e) {
    e.preventDefault();
    $(this).hide();
    $.post($(this).attr('action'), $(this).serialize(), (response) => {
        $(this).closest('.profile-follow-container').after(response);
    });
});

$(document).on('submit', '.js-btn-follow', function (e) {
    e.preventDefault();
    utils.redirectAnonymous();
    $('#profileFollowingPush').toggleClass('d-none');
    $('#profileFollowingPush input').prop("checked", true);
});

$(document).on('change', '#updFollowPush', function (e) {
    e.preventDefault();
    let form = $(this).closest('form');
    $.post(form.attr('action'), form.serialize(), (response) => { });
});

$(document).on("change", ".profile_configuration_notification_switch", async function (e) {
    const type = e.target.dataset.biType;

    const formData = new FormData();
    formData.append("notification", $(this).attr("id").replace("_switch", ""));
    formData.append("unsubscribe", !$(this).is(":checked"));
    formData.append("categoryId", $(this).attr("category-id"));
    $.post({
        url: "/profile/set_notification_preference",
        contentType: false,
        processData: false,
        data: formData
    });

    if(this.id === 'push_newsletter_switch') {
        if(await utils.canCallApp('setCleverTapPush')) {
            Trendier.setCleverTapPush(
                $(this).is(":checked") ? '1' : '0',
            );
        }
    }

    const resolveAction = (status, noti) => {
        const statusCheckbox = status === 'true' ? 'disable' : 'enable';
        const notificationCheckbox = noti.includes('email') ? 'email' : 'app';
        return `${statusCheckbox}_${notificationCheckbox}`;
    }

    const userAlertConfigureBIModel = new UserAlertConfigureBIModel(
        utils.config.user.id,
        resolveAction(Object.fromEntries(formData).unsubscribe, Object.fromEntries(formData).notification),
        type
    );
    BI.track(userAlertConfigureBIModel);
    
});

$(document).on('click', '.profile-configuration .icon-close-circle-filled', function () {
    $(this).parents('.input-group').find('input').val('');
    $('.js-filter-brands-results').html('');
    $(this).addClass('invisible');
});

$(document).on('change', '.js-vacation-mode-switch', function () {
    $('.vacation-mode-calendar').toggleClass("d-none", !$(this).prop("checked"));
    $('input[name="awayModeStatusReal"]').val($(this).prop("checked") ? 1 : 0);
    $('input[name="vacations_start_date"]').prop("disabled", !$(this).prop("checked"));
    $('input[name="vacations_end_date"]').prop("disabled", !$(this).prop("checked"));
});

$(document).on('change', '.js-upload-image input[type="file"]', function () {
    let placeholder = $(this).closest('.js-upload-image');
    $('#cropImageBtn').data('placeholder', placeholder);
    getImageBase64(this).then(
        imgBase64 => {
            $('.upload-demo').addClass('ready');
            $('#cropImagePop').modal('show');
            $('#cropImagePop .cropper-loading-spinner').addClass('d-none');
            document.getElementById('upload-demo').src = imgBase64;
        }
    )
});

// Crop - bind on modal open
$('#cropImagePop').on('shown.bs.modal', function () {
    cropperObj = new Cropper(document.getElementById('upload-demo'), {
        aspectRatio: 1,
        dragMode: 'move',
        strict: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'medium',
        autoCropArea: 1,
        background: false
    });
    $(document).on('click', '.js-profile-button-zoom', function () {
        cropperObj.zoom($(this).data('zoom'));
    });
}).on('hidden.bs.modal', function () {
    cropperObj.destroy();
    utils.btnLoading($('#cropImageBtn'), false);
    document.getElementById('upload-demo').src = '';
    $('#cropImagePop .cropper-loading-spinner').removeClass('d-none');
});
    

const sendImageServer = (canvas = null, imgBase64 = null, callback) => {

    const base64img = canvas ? trimCanvas(canvas).toDataURL("image/jpeg") : imgBase64;
    const block = base64img.split(";");
    const contentType = block[0].split(":")[1];
    const realData = block[1].split(",")[1];
    const blob = b64toBlob(realData, contentType);

    let formData = new FormData();
    formData.append('file', blob);

    fetch('/api/v4/user/image', {
        method: 'POST',
        body: formData,
        credentials: 'include',
    })
        .then((response) => {
            if (response.status === 413) {
                throw new Error('Image is too large.');
            } else if (!response.ok) {
                throw new Error('Image upload failed!');
            }
            return response.json();
        })
        .then((data) => {
            callback(data);
        })
        .catch((error) => {
            console.error('Error uploading image in profile:', error);
        });
}

// Crop - Crop image and send to server
$(document).on('click', '#cropImageBtn', function () {
    $.when(utils.btnLoading($(this))).then(function () {    
        let placeholder = $('#cropImageBtn').data('placeholder'),
            canvas = cropperObj.getCroppedCanvas();
                placeholder.find('.js-spinner').removeClass('d-none');
                sendImageServer(canvas, null, ({ url }) => {
                    const pathInput = $('input[name="' + placeholder.data('input') + '"]');
                    placeholder.find('img').attr('src', url);
                    placeholder.find('.js-spinner').addClass('d-none');
                    placeholder.find('.icon-close').removeClass('d-none');
                    pathInput.val(url).change();
                });
            $('#cropImagePop').modal('hide');
        });
});

$(document).on('click', '.edit-about-me', function (e) {
    e.preventDefault();

    document.querySelectorAll('.js-about-me-toggable').forEach(toggable => {
        toggable.classList.toggle('d-none');
    });
    $('.input-about-me:visible').focus();
    $('.input-about-me:visible').click();
});

onLoad( async () => {
    const profilePage = document.querySelector('.js-profile-follow-buttons');
    const uid = profilePage ? parseInt(profilePage.dataset.uid) : null;

    if (await appHasCapability('brands-alerts-edit')) {
        const customizationBrands = document.querySelector('.js-customization-brands');
        const customizationAlerts = document.querySelector('.js-customization-alerts');
        if (customizationBrands && customizationAlerts) {
            customizationBrands.classList.add('d-none');
            customizationAlerts.classList.add('d-none');
        }
    }

    //
    // Open native publish in draft
    const appHasNativeDraft =
            await appHasCapability('link-open-publish-draft-profile');
    document.addEventListener('click', async e => {
        const isOwnDraft = e.target?.classList.contains('js-draft-own-product');
        if (!isOwnDraft || !appHasNativeDraft || !utils.canCallApp('editProduct'))
                return;
        e.preventDefault();
        Trendier.editProduct(e.target.id.replace(/[^0-9]/g, ''));
    });

    if (profilePage && utils.isLogged()) {
        Ajax.get('/profile/ajax', {
            uid: uid
        }).then(response => {
            if (response.error) {
                return;
            }

            response = response.result;

            if (response.follows) {
                document.querySelectorAll('.js-btn-follow').forEach((el) => {
                    el.querySelector('.follow').classList.add('d-none');
                    el.querySelector('.unfollow').classList.remove('d-none');
                    el.querySelector('[name="following"]').value = 1;
                });

                document.querySelector("#profileFollowingPush").classList.remove("d-none");

                if (response.acceptPushUser) {
                    document.querySelector('#updFollowPush').checked = "checked";
                }
            }

            document.querySelector('[data-accept-push-global="' + response.acceptPushGlobal + '"]').classList.remove("d-none");
        });
    }

    // User unsubscribe. Toggle textarea
    var unsuscribe_user_input = document.querySelector('#unsuscribe_user input[value="other"]');
    if (unsuscribe_user_input) {
        unsuscribe_user_input.addEventListener('click', () => document.querySelector('#other_reasons_text').classList.toggle('show'));
    }

    if (location.hash.length) {
        const [hashFiltered, query] = window.location.href.split('#')[1].split('?');

        // Si la url tiene un hash, buscamos el elemento con ese id (p.ej product-id-306134) y lo desplegamos
        if (hashFiltered.substring(0, 11) === 'product-id-') {
            let productContainer = document.querySelector(`#${CSS.escape(hashFiltered)}`);

            if (productContainer) {
                let toggle = productContainer.querySelector('.js-transaction-data-toggle');
                if (toggle && toggle.offsetParent) { //Si es visible (mobile)
                    toggle.click();
                }
            }
        }

        // Modal que cargamos cuando en la url del profile aparece el hash "seguidoras"
        if (hashFiltered === 'seguidoras' && uid) {
            $('#modal-profile-followers').modal('show');
            $('#modal-profile-followers .modal-body').load('/profile/followers/' + uid, () => {
                $('.js-spinner').toggleClass('d-none, d-flex');
            });
        }
    }

    document.querySelectorAll('.js-form-add-about-me').forEach(form => form.addEventListener('submit', e => {
        e.preventDefault();
        if (document.querySelector('.js-input-about-me').value != '') {
            var formData = new FormData(form);
            Ajax.post(form.action, formData);
            document.querySelectorAll('.js-about-me-toggable').forEach(toggable => {
                toggable.classList.toggle('d-none');
            });
            document.querySelector('.js-about-me-content-box').textContent = document.querySelector('.js-input-about-me').value;
        }

    }));

    document.querySelectorAll('.js-show-dispute-summary').forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            let id = btn.dataset.disputeId,
                method = "summary";

            if (typeof id === "undefined") {
                id = btn.dataset.transactionId;
                method = "refund";
            }

            Ajax.post('/claim/' + method + '/' + id)
                .then(template => {
                    document.querySelector('#modal-dispute-summary .modal-body').innerHTML = template.result;
                    $('#modal-dispute-summary').modal('show');
                });
        });
    });

    // WhoToFollow section
    if (document.body.classList.contains('js-who-to-follow')) {
        const formWhoToFollow = document.querySelector('.js-who-to-follow-form');
        const getSegmentUsers = async (segment, page) => await Ajax.get(`/whotofollow`, {segment: segment, page: page}, false);
        let emptySegments = [];

        $('a[data-toggle="pill"]').on('shown.bs.tab', async (e) => {
            const slugActive = e.target?.dataset.slug;
            const valueActive = e.target?.dataset.value;
            const orderActive = e.target?.dataset.order;
            const contentActive = document.getElementById(`pills-${slugActive}`);
            const emptyTab = contentActive.querySelector('.no-results');
            const query = document.querySelector('[data-bi-whotofollow-query]');
            
            if (slugActive) {
                query.dataset.biWhotofollowQuery = slugActive;
                document.querySelector('[name="userSegmentTab"]').value = slugActive;
            }

            if (emptyTab && !emptySegments.includes(slugActive)) {
                const segmentUsersHtml = await getSegmentUsers(slugActive);
                if (!segmentUsersHtml) {
                    emptySegments.push(slugActive);
                    emptyTab.classList.remove('d-none');
                } else {
                    contentActive.innerHTML = await segmentUsersHtml;
                    setScrollLoading(); //Set for ajax created content
                }
            }
        })

        setScrollLoading();
    }

    cloneProductSetupBtns();
    (() => {
        if (!safeLocalStorage.getItem('hide-republish-badge-text')) {
            const republishBadgeText = document.querySelector('.republish-badge-text');
            if (republishBadgeText) {
                window.setTimeout(() => {
                    republishBadgeText.classList.add('showing');
                    republishBadgeText.nextElementSibling?.classList.remove('shadow'); // Reference to icon badge without text
                    window.setTimeout(() => {
                        republishBadgeText.classList.remove('showing');
                        republishBadgeText.nextElementSibling?.classList.add('shadow'); // Reference to icon badge without text
                        safeLocalStorage.setItem('hide-republish-badge-textt', '1');
                    }, 3000);
                }, 1000);
            }
        }
    })();


    // BEGIN --> Send user_review_start event BI tracking on click "Califica a tu vendedora"
       (() => {
            const elementUserReviewStart = document.querySelector('.js-bi-user-review-start');
            const handleUserReviewStart = () => {
                const userReviewStartBIModel = new UserReviewStartBIModel(utils.user.id, elementUserReviewStart.dataset.biSellerId, elementUserReviewStart.dataset.biProductId);
                BI.track(userReviewStartBIModel);
            }
            
            if (elementUserReviewStart) {
                elementUserReviewStart.addEventListener('click', handleUserReviewStart);
            }
        })()
    // END --> Send user_review_start event BI tracking on click "Califica a tu vendedora"

    appPdf();

    setPublishedProductsIndicator( '.js-published-products-indicator' );

    bannerFriendDiscount();
    
    if (!utils.isApp() && !utils.isAppSubdomain() ) {
        userReportBlock.init();
    }

    if (utils.config.ownerCloset) {
        sendAppEvent('view_own_profile');
    }

    document.querySelectorAll('.js-change-email').forEach(link => {
        link.addEventListener('click', () => 
            fetch('/api/v5/mails/change_email', {method : 'POST'})
            .then(response => response.ok ? response.json() : response.text().then(text => { throw {status: response.status, text: text}; }))
            .then(() => utils.defaultAlertModal('Hemos enviado las instrucciones para cambiar tu email a tu correo actual'))
            .catch(() => utils.defaultAlertModal('Se ha producido algún error, inténtalo mas tarde.'))
        );
    });
});

const setScrollLoading = () => {
  const elemsBeforeScroll = 5;
  const tabUsers = document.querySelector('.tab-pane.show .js-infinite-scroll');
  if (!tabUsers || tabUsers.length > elemsBeforeScroll)
      return;
  const observer = new IntersectionObserver(async entries => {            
    if (entries[0].isIntersecting) {
      const userSegment = document.querySelector('[name="userSegmentTab"]').value;
      const txtSearch = document.querySelector('[name="txtSearch"]').value;
      await fetch('/whotofollow?scroll-infinite=1&segment=' + userSegment)
        .then(async response => {
          const parser = new DOMParser();
          const html = parser.parseFromString(await response.text(), 'text/html'); //Response to HTML
          const parentContainer = document.querySelector(
              '.tab-pane.show .js-infinite-scroll');
          const elems = html.querySelectorAll('.js-infinite-scroll > *');
          if (parentContainer && txtSearch.length < 1) {
            parentContainer.lastElementChild.classList.add(
                'border-bottom', 'border-grey-200'); //Add separation line to last user elem
            elems.forEach(user => {
              parentContainer.appendChild(user);
            });
          }
          observer.disconnect(); //Avoid new calls if the user scrolls up & down
          setScrollLoading(); //Set the observer for the new added elems
        })
        .catch(() => {});
    }
  });
  const elemToObserve = document.querySelector(
      `.tab-pane.show .js-infinite-scroll >
      *:nth-last-child(${elemsBeforeScroll})`);
  if (elemToObserve) observer.observe(elemToObserve);
};

shippingDataChecks();
